import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { htmlHasUnsupportedBlockNode } from '../../helpers/blockContentValidation.helper';

type TOptions = {
  onUnsupportedPaste: () => void;
};

// Reads the raw html of a paste or drop: the parsed slice has already lost the nodes the content block schema lacks.
const BlockPasteWarning = Extension.create<TOptions>({
  name: 'block-paste-warning',

  addOptions() {
    return { onUnsupportedPaste: () => undefined };
  },

  addProseMirrorPlugins() {
    const { onUnsupportedPaste } = this.options;
    return [
      new Plugin({
        key: new PluginKey('block-paste-warning'),
        props: {
          transformPastedHTML: (html) => {
            if (htmlHasUnsupportedBlockNode(html)) onUnsupportedPaste();
            return html;
          },
        },
      }),
    ];
  },
});

export default BlockPasteWarning;
